let routes_prod = true;
let routes_test = false;

const local_routes = {
    health: "http://localhost:8000/health",
    auth: "http://localhost:8000/v4/auth",
    channel: "http://localhost:8000/v4/channel",
    upload: "http://localhost:8000/v4/video",
    channel_playlist: "http://localhost:8000/v4/playlist",
    upload_states: "http://localhost:8000/v4/channel/uploads",
    submissions: "http://localhost:8000/v4/submission"
}

const testing_routes = {
    health: "https://creators.hearthfireradio.com/health",
    auth: "https://creators.hearthfireradio.com/v4/auth",
    channel: "https://creators.hearthfireradio.com/v4/channel",
    upload: "https://creators.hearthfireradio.com/v4/video",
    channel_playlist: "https://creators.hearthfireradio.com/v4/playlist",
    upload_states: "https://creators.hearthfireradio.com/v4/channel/uploads",
    submissions: "https://creators.hearthfireradio.com/v4/submission"
}

const prod_routes = {
    health: "https://creators.hearthfireradio.com/health",
    auth: "https://creators.hearthfireradio.com/v4/auth",
    channel: "https://creators.hearthfireradio.com/v4/channel",
    upload: "https://creators.hearthfireradio.com/v4/video",
    channel_playlist: "https://creators.hearthfireradio.com/v4/playlist",
    upload_states: "https://creators.hearthfireradio.com/v4/channel/uploads",
    submissions: "https://creators.hearthfireradio.com/v4/submission"
}

let routes = routes_test ? testing_routes : routes_prod ? prod_routes : local_routes;

export default routes;